import { render } from "./PublicationLogin.vue?vue&type=template&id=4318adee"
import script from "./PublicationLogin.vue?vue&type=script&lang=js"
export * from "./PublicationLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__